import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import store from "./store";

import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLayout from "./components/AdminLayout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Service from "./pages/Service";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminGalleryUpload from "./pages/admin/AdminGalleryUpload";
import AdminSlider from "./pages/admin/AdminSlider";
import AdminInquiryDetail from "./pages/admin/AdminInquiryDetail";

import { AuthProvider } from "./context/AuthContext";
import "./assets/css/main.css";

const PublicLayout = () => (
  <div className="App">
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);

const AdminLayoutWrapper = () => (
  <AdminLayout>
    <Outlet />
  </AdminLayout>
);

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              {/* Public routes */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/service" element={<Service />} />
              </Route>

              {/* Admin login — standalone (no sidebar, no public header) */}
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Admin routes — all wrapped in sidebar layout */}
              <Route element={<AdminLayoutWrapper />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/products/new" element={<AdminProductForm />} />
                <Route path="/admin/products/:id/edit" element={<AdminProductForm />} />
                <Route path="/admin/gallery" element={<AdminGallery />} />
                <Route path="/admin/gallery/upload" element={<AdminGalleryUpload />} />
                <Route path="/admin/slider" element={<AdminSlider />} />
                <Route path="/admin/inquiries" element={<AdminInquiries />} />
                <Route path="/admin/inquiries/:id" element={<AdminInquiryDetail />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </Router>

          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
